
























import { Component } from 'vue-property-decorator';
import { DataStateChangeEventArgs } from "@syncfusion/ej2-vue-grids";
import { ClickEventArgs } from '@syncfusion/ej2-vue-navigations';
import CFMGridPage from '@/scripts/CFMGridPage'

import * as swal from '@/helpers/swal'
import * as blockui from '@/helpers/block-ui'

import { CFMDTOToolType } from '@/scripts/services/ClientApiAuto'
import ToolTypeDialog from './ToolTypeDialog.vue'

@Component<NewToolType>({
    components: {
        'tool-type-dialog': ToolTypeDialog,
    }
})
export default class NewToolType extends CFMGridPage<CFMDTOToolType> {
    entityType = "ToolType";
    sorts:{field:string,direction:string}[] = [{ field:"Id", direction:"Descending" }];

    async mounted(){
        this.dataStateChange(this.state);
    }
    refreshGrid(){
        this.dataStateChange(this.state);
    }
    recordDoubleClick(args:any){
        this.edit(args.rowData.Id);
    }
    async delete(data: CFMDTOToolType){
        const e = await swal.check(this, data.Name);
        if (e.value) {
            blockui.pageBlock(this);
            const response = await this.apiClient.toolType.toolTypeDelete({id: data.Id});
            if (response.data.IsSuccess) {
                toastr.success(this.translate('delete_successfully'));
                this.refreshGrid();
            } else {
                const errorMessage = response.data.Message ? response.data.Message : "Error";
                toastr.error(errorMessage);
            }
            blockui.unBlockPage();
        }
    }
    async edit(id: number){
        this.selectedId = id;
        this.isDialogActive = true;
        await this.$nextTick();
        (<ToolTypeDialog>this.$refs.toolTypeDialog).showDialog();
    }
    async add(){
        this.selectedId = null;
        this.isDialogActive = true;
        await this.$nextTick();
        (<ToolTypeDialog>this.$refs.toolTypeDialog).showDialog();
    }
    async toolbarClick(args: ClickEventArgs){
        var selectedRecords = (<any>this.$refs.grid).getSelectedRecords();
        if (args.item.id === 'Edit') {
            if(selectedRecords.length > 0){
                this.edit(selectedRecords[0].Id);
            }
        }
        else if(args.item.id === 'Add'){
               this.add();
        }
        else if(args.item.id === 'Delete'){
            if(selectedRecords.length > 0){
                this.delete(selectedRecords[0]);
            }
        }
      this.toolbarClickBase(args);
    }
}
